exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oc {\n  padding: 71px 0px 65px;\n}\n.oc-con {\n  background: #fff;\n  padding: 20px;\n}\n.oc-con h2 {\n  font-weight: bolder;\n  color: #666;\n}\n.oc-con p {\n  color: #666;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#1DA57A"}}!./src/style/oc.less
// module id = 1137
// module chunks = 0